<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t('label.statistic') }}
      </h3>
    </div>
    <div class="box-body">
      <div class="table-responsive">
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr class="bg-gray text-uppercase">
              <th rowspan="3" />
              <th
                rowspan="3"
                class="text-center"
              >
                {{ $t('score.totalClient') }}
              </th>
              <th
                colspan="5"
                class="text-center"
              >
                Loan
              </th>
            </tr>
            <tr class="bg-gray text-uppercase">
              <th
                class="text-primary text-center"
                rowspan="2"
              >
                {{ $t('score.open') }}
              </th>
              <th
                class="text-danger text-center"
                colspan="2"
              >
                {{ $t('score.defaulted') }}
              </th>
              <th
                class="text-success text-center"
                rowspan="2"
              >
                {{ $t('score.fullyPaid') }}
              </th>
              <th
                class="text-warning text-center"
                rowspan="2"
              >
                {{ $t('score.restructured') }}
              </th>
            </tr>
            <tr class="bg-gray text-uppercase">
              <th class="text-center">
                {{ $t('score.amount') }}
              </th>
              <th class="text-center">
                {{ $t('score.percentage') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="counts.length > 0">
              <tr
                v-for="(item, key) in counts"
                :key="key"
              >
                <td>{{ item.value }}</td>
                <td>{{ item.total_client }}</td>
                <td>{{ item.open }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.percentage }}%</td>
                <td>{{ item.fully_paid }}</td>
                <td>{{ item.restructured }}</td>
              </tr>
              <tr class="bg-gray">
                <td><strong>Total</strong></td>
                <td><strong>{{ totalCounts.client }}</strong></td>
                <td><strong>{{ totalCounts.open }}</strong></td>
                <td><strong>{{ totalCounts.default }}</strong></td>
                <td><strong>{{ totalCounts.percentage | percentage }}</strong></td>
                <td><strong>{{ totalCounts.fully_paid }}</strong></td>
                <td><strong>{{ totalCounts.restructured }}</strong></td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td
                  class="text-center"
                  colspan="7"
                >
                  {{ $t('string.noMatchingRecordsFound') }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CashHeroStatistic',
  data () {
    return {
      column: 'age',
      counts: []
    }
  },
  computed: {
    ...mapState('profileScoring', {
      selectedCriteria: 'selectedCriteria'
    }),
    totalCounts () {
      const total = {
        client: 0,
        open: 0,
        default: 0,
        percentage: 0,
        fully_paid: 0,
        restructured: 0
      }
      if (Array.isArray(this.counts) && this.counts.length) {
        total.client = this.counts.map(item => item.total_client).reduce((acc, curr) => acc + curr)
        total.open = this.counts.map(item => item.open).reduce((acc, curr) => acc + curr)
        total.default = this.counts.map(item => item.amount).reduce((acc, curr) => acc + curr)
        total.fully_paid = this.counts.map(item => item.fully_paid).reduce((acc, curr) => acc + curr)
        total.restructured = this.counts.map(item => item.restructured).reduce((acc, curr) => acc + curr)
        total.percentage = total.default / total.client
      }
      return total
    }
  },
  watch: {
    selectedCriteria () {
      this.setColumn()
      this.getData()
    }
  },
  methods: {
    setColumn () {
      switch (this.selectedCriteria.name_en) {
        case 'Gender':
          this.column = 'gender'
          break
        case 'Marital Status':
          this.column = 'marital_status'
          break
        case 'Age':
          this.column = 'age'
          break
        case 'Province':
          this.column = 'province'
          break
        case 'District':
          this.column = 'district'
          break
        case 'Address Duration':
          this.column = 'how_long_have_been_living_there'
          break
        case 'Loan Purpose':
          this.column = 'loan_type_id'
          break
        case 'Education Level':
          this.column = 'borrow_education_id'
          break
        case 'School Name':
          this.column = 'school_name'
          break
        case 'Occupation':
          this.column = 'occupation'
          break
        case 'Company Name':
          this.column = 'company_name'
          break
        case 'Type of Organization':
          this.column = 'company_type'
          break
        case 'Monthly Income':
          this.column = 'gross_monthly_income'
          break
        case 'Study Major':
          this.column = 'study_major'
          break
        case 'Home Type':
          this.column = 'home_type'
          break
        default:
          break
      }
    },
    getData () {
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/profile-scoring/get-data', {
        column: this.column
      }).then(({ data }) => {
        if (data.data) {
          this.counts = data.data
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid black;
  padding-left: 6px;
  padding-right: 6px;
}
</style>
